/* ============================================================
   SAMANÁ — scripts del tema (vanilla, sin librerías)
   Cada init comprueba si su elemento existe, así el archivo
   sirve para todas las páginas.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Animaciones de entrada ---- */
  function initReveals() {
    var els = document.querySelectorAll('.sm-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sm-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('sm-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Selector interactivo de Blueblockers ---- */
  function initBlueblockers() {
    var root = document.querySelector('[data-sm-bb]');
    if (!root) return;

    var lensChips = root.querySelectorAll('[data-sm-lens]');
    var frameChips = root.querySelectorAll('[data-sm-frame]');
    var descEl = root.querySelector('[data-sm-bb-desc]');
    var badgeLens = root.querySelector('[data-sm-badge-lens]');
    var badgeFrame = root.querySelector('[data-sm-badge-frame]');
    var tint = root.querySelector('[data-sm-bb-tint]');
    var photoLabel = root.querySelector('[data-sm-bb-label]');

    function selectLens(chip) {
      lensChips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      if (descEl) descEl.textContent = chip.getAttribute('data-desc') || '';
      var hex = chip.getAttribute('data-hex');
      if (tint && hex) tint.style.background = hex;
      if (badgeLens) {
        badgeLens.textContent = chip.getAttribute('data-label') || '';
        badgeLens.className = 'sm-badge sm-badge--' + (chip.getAttribute('data-tone') || 'copper');
      }
      updateLabel();
    }
    function selectFrame(chip) {
      frameChips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      if (badgeFrame) badgeFrame.textContent = chip.getAttribute('data-label') || '';
      updateLabel();
    }
    function updateLabel() {
      if (!photoLabel) return;
      var f = root.querySelector('[data-sm-frame][aria-pressed="true"]');
      var l = root.querySelector('[data-sm-lens][aria-pressed="true"]');
      photoLabel.textContent = ((f && f.getAttribute('data-label')) || '') + ' · ' + ((l && l.getAttribute('data-label')) || '');
    }

    lensChips.forEach(function (c) { c.addEventListener('click', function () { selectLens(c); }); });
    frameChips.forEach(function (c) { c.addEventListener('click', function () { selectFrame(c); }); });
  }

  /* ---- Galería de producto ---- */
  function initGallery() {
    var gallery = document.querySelector('[data-sm-gallery]');
    if (!gallery) return;
    var mainImg = gallery.querySelector('[data-sm-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-sm-thumb]');
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (full) mainImg.src = full;
        thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      });
    });
  }

  /* ---- Variantes de producto ---- */
  function initVariants() {
    var form = document.querySelector('[data-sm-product-form]');
    if (!form) return;
    var dataEl = document.querySelector('[data-sm-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-sm-price]');
    var addBtn = form.querySelector('[data-sm-add]');
    var selects = form.querySelectorAll('[data-sm-option]');
    var moneyFormat = dataEl.getAttribute('data-money-format') || '${{amount}}';

    // Shopify tiene varios formatos de precio segun el pais. Antes solo se
    // reconocia {{amount}}: con el formato de Argentina
    // ({{amount_with_comma_separator}}) se mostraba el texto crudo en pantalla.
    function armar(cents, sepMiles, sepDecimal, decimales) {
      var partes = (cents / 100).toFixed(decimales).split('.');
      var entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, sepMiles);
      return decimales > 0 ? entero + sepDecimal + partes[1] : entero;
    }
    function formatMoney(cents) {
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (todo, clave) {
        switch (clave) {
          case 'amount_no_decimals': return armar(cents, ',', '.', 0);
          case 'amount_with_comma_separator': return armar(cents, '.', ',', 2);
          case 'amount_no_decimals_with_comma_separator': return armar(cents, '.', ',', 0);
          case 'amount_with_apostrophe_separator': return armar(cents, "'", '.', 2);
          default: return armar(cents, ',', '.', 2);
        }
      });
    }
    function currentSelections() {
      return Array.prototype.map.call(selects, function (s) { return s.value; });
    }
    function findVariant(sel) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      });
    }
    function update() {
      var v = findVariant(currentSelections());
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = (v.compare_at_price && v.compare_at_price > v.price ? '<s>' + formatMoney(v.compare_at_price) + '</s> ' : '') + formatMoney(v.price);
      if (addBtn) {
        if (v.available) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute('data-label') || 'Agregar al carrito'; }
        else { addBtn.disabled = true; addBtn.textContent = 'Agotado'; }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });

    // Botones de opción (chips) que controlan cada <select> oculto
    var optBtns = form.querySelectorAll('[data-sm-opt-btn]');
    optBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        var val = btn.getAttribute('data-value');
        if (selects[idx]) { selects[idx].value = val; }
        // marcar el chip activo dentro de su grupo
        var group = btn.parentNode.querySelectorAll('[data-sm-opt-btn]');
        group.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        update();
      });
    });

    update();
  }

  /* ---- Menú móvil ---- */
  function initMobileMenu() {
    var burger = document.querySelector('[data-sm-burger]');
    var nav = document.querySelector('[data-sm-nav]');
    if (!burger || !nav) return;
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('sm-header__nav--open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---- Efecto linterna (spotlight sigue al cursor) ---- */
  function initSpotlight() {
    var els = document.querySelectorAll('[data-sm-spotlight]');
    if (!els.length) return;
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;
    els.forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--sm-mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        el.style.setProperty('--sm-my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
    });
  }

  /* ---- Conteo animado de estadísticas ---- */
  function initCountUp() {
    var nums = document.querySelectorAll('[data-count]');
    if (!nums.length) return;
    function fill(n) { n.textContent = (n.getAttribute('data-prefix') || '') + (n.getAttribute('data-count') || '') + (n.getAttribute('data-suffix') || ''); }
    if (reduceMotion || !('IntersectionObserver' in window)) { nums.forEach(fill); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var n = e.target; io.unobserve(n);
        var target = parseFloat(n.getAttribute('data-count')) || 0;
        var suffix = n.getAttribute('data-suffix') || '';
        var prefix = n.getAttribute('data-prefix') || '';
        var dur = 1400, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = Math.round(target * (1 - Math.pow(1 - p, 3)));
          n.textContent = prefix + eased + suffix;
          if (p < 1) { requestAnimationFrame(step); } else { n.textContent = prefix + target + suffix; }
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---- Carrusel ---- */
  function initCarousels() {
    var roots = document.querySelectorAll('[data-sm-carru]');
    if (!roots.length) return;
    roots.forEach(function (root) {
      var vp = root.querySelector('[data-sm-carru-viewport]');
      var slides = root.querySelectorAll('.sm-carru__slide');
      var prev = root.querySelector('[data-sm-carru-prev]');
      var next = root.querySelector('[data-sm-carru-next]');
      var dotsWrap = root.querySelector('[data-sm-carru-dots]');
      if (!vp || !slides.length) return;

      function step() {
        if (slides.length < 2) return vp.clientWidth;
        return slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
      }
      if (prev) prev.addEventListener('click', function () { vp.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { vp.scrollBy({ left: step(), behavior: 'smooth' }); });

      if (dotsWrap) {
        slides.forEach(function (s, i) {
          var d = document.createElement('button');
          d.className = 'sm-carru__dot';
          d.setAttribute('aria-label', 'Ir al slide ' + (i + 1));
          if (i === 0) d.setAttribute('aria-current', 'true');
          d.addEventListener('click', function () { vp.scrollTo({ left: s.offsetLeft - vp.offsetLeft, behavior: 'smooth' }); });
          dotsWrap.appendChild(d);
        });
        var dots = dotsWrap.querySelectorAll('.sm-carru__dot');
        var raf;
        vp.addEventListener('scroll', function () {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            var idx = Math.round(vp.scrollLeft / step());
            idx = Math.max(0, Math.min(dots.length - 1, idx));
            dots.forEach(function (d, i) { if (i === idx) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); } });
          });
        });
      }
    });
  }

  /* ---- Sticky CTA móvil ---- */
  function initStickyCta() {
    var bar = document.querySelector('[data-sm-sticky]');
    if (!bar) return;
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var nearBottom = (y + window.innerHeight) > (document.body.scrollHeight - 260);
      if (y > window.innerHeight * 0.85 && !nearBottom) { bar.classList.add('sm-visible'); }
      else { bar.classList.remove('sm-visible'); }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---- Barra de progreso de lectura ---- */
  function initProgress() {
    if (document.querySelector('.sm-progress')) return;
    var bar = document.createElement('div');
    bar.className = 'sm-progress';
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      ticking = false;
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      var p = max > 0 ? (window.pageYOffset || doc.scrollTop) / max : 0;
      bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, p)).toFixed(4) + ')';
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---- Header que se encoge al scrollear ---- */
  function initHeaderScroll() {
    var header = document.querySelector('.sm-header');
    if (!header) return;
    function update() { header.classList.toggle('sm-header--scrolled', (window.pageYOffset || 0) > 12); }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---- Video del hero: forzar reproducción si el autoplay fue bloqueado ---- */
  function initHeroVideo() {
    var v = document.querySelector('.sm-hero-ov video');
    if (!v) return;
    v.muted = true;
    v.setAttribute('muted', '');
    var userPaused = false;
    function tryPlay() {
      if (userPaused) return;
      var p = v.play();
      if (p && p.catch) { p.catch(function () {}); }
    }
    tryPlay();
    v.addEventListener('canplay', tryPlay, { once: true });
    // Ahorro de batería/datos bloquea el autoplay: reintentar al primer toque o scroll
    window.addEventListener('touchstart', tryPlay, { passive: true, once: true });
    window.addEventListener('scroll', tryPlay, { passive: true, once: true });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-sm-video-toggle]')) return;
      tryPlay();
    }, { once: true });

    // Botón chico de play/pausa (abajo a la derecha)
    var btn = document.querySelector('[data-sm-video-toggle]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (v.paused) { userPaused = false; v.play().catch(function () {}); }
        else { userPaused = true; v.pause(); }
      });
      v.addEventListener('play', function () { btn.classList.add('sm-playing'); });
      v.addEventListener('pause', function () { btn.classList.remove('sm-playing'); });
      if (!v.paused) btn.classList.add('sm-playing');
    }
  }

  /* ---- Header transparente SOBRE el hero (el video pasa por detrás) ---- */
  function initOverHero() {
    var header = document.querySelector('.sm-header--overhero');
    if (!header) return;
    var wrap = header.closest('.shopify-section') || header.parentElement;
    function fit() { wrap.style.marginBottom = '-' + header.offsetHeight + 'px'; }
    window.addEventListener('resize', fit, { passive: true });
    fit();
  }

  /* ---- Reseñas: bucle sin huecos y pausable ----
     El bucle son dos mitades idénticas y la animación llega justo a -50%.
     Para que nunca se vea un hueco, cada mitad tiene que ser al menos tan ancha
     como la pantalla: si no llega, se clonan tarjetas hasta que llegue.
     (Antes se repartía el espacio sobrante, pero eso separaba demasiado las tarjetas.) */
  function initResenas() {
    var marquesinas = document.querySelectorAll('.sm-res__marquee');
    Array.prototype.forEach.call(marquesinas, function (m) {
      var mitades = m.querySelectorAll('.sm-res__half');
      if (mitades.length < 2) return;

      var original = Array.prototype.slice.call(mitades[0].children);
      if (!original.length) return;

      function rellenar() {
        // Volver al estado original antes de recalcular (por si cambió el ancho).
        Array.prototype.forEach.call(mitades, function (mitad) {
          while (mitad.children.length > original.length) mitad.removeChild(mitad.lastChild);
        });

        var necesario = m.clientWidth;
        var vueltas = 0;
        while (mitades[0].scrollWidth < necesario && vueltas < 12) {
          Array.prototype.forEach.call(mitades, function (mitad) {
            original.forEach(function (tarjeta) {
              var copia = tarjeta.cloneNode(true);
              copia.setAttribute('aria-hidden', 'true');
              mitad.appendChild(copia);
            });
          });
          vueltas++;
        }
      }

      rellenar();

      var pista = m.querySelector('.sm-res__track');
      if (!pista || !window.requestAnimationFrame) return;

      // A partir de acá lo maneja el JS: en vez de animar con CSS, se mueve el
      // scroll. Así sigue andando solo PERO la persona puede arrastrarlo con el
      // dedo para ir a la siguiente reseña (con la animación CSS no se podía).
      m.classList.add('is-manual');

      var pausado = false;
      var reanudar;
      var anterior = 0;

      function anchoMitad() { return mitades[0].getBoundingClientRect().width; }

      // Misma velocidad que tenía la animación: una vuelta completa (una mitad)
      // en los segundos que indica --sm-res-speed.
      function pxPorSegundo() {
        var seg = parseFloat(getComputedStyle(m).getPropertyValue('--sm-res-speed')) || 42;
        return anchoMitad() / seg;
      }

      function paso(t) {
        if (!anterior) anterior = t;
        var dt = Math.min((t - anterior) / 1000, 0.05); // si la pestaña estuvo oculta, no saltar
        anterior = t;

        if (!pausado) m.scrollLeft += pxPorSegundo() * dt;

        // Bucle sin costura: las dos mitades son idénticas, así que al pasar una
        // mitad se vuelve al principio y no se nota.
        var mitad = anchoMitad();
        if (mitad > 0) {
          if (m.scrollLeft >= mitad) m.scrollLeft -= mitad;
          else if (m.scrollLeft <= 0) m.scrollLeft += mitad;
        }
        requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);

      function pausar() { pausado = true; clearTimeout(reanudar); }
      function soltar(espera) {
        clearTimeout(reanudar);
        reanudar = setTimeout(function () { pausado = false; }, espera);
      }

      // Con el mouse encima se frena para poder leer.
      m.addEventListener('mouseenter', pausar);
      m.addEventListener('mouseleave', function () { soltar(200); });
      // Con el dedo (o arrastrando) se frena y se reanuda un rato después de soltar.
      m.addEventListener('pointerdown', pausar);
      ['pointerup', 'pointercancel'].forEach(function (ev) {
        m.addEventListener(ev, function () { soltar(1200); });
      });
      m.addEventListener('touchstart', pausar, { passive: true });
      m.addEventListener('touchend', function () { soltar(1200); }, { passive: true });
      m.addEventListener('wheel', function () { pausar(); soltar(1200); }, { passive: true });

      var pendiente;
      window.addEventListener('resize', function () {
        clearTimeout(pendiente);
        pendiente = setTimeout(rellenar, 250);
      }, { passive: true });
    });
  }

  function boot() {
    // El script se incluye desde varias secciones: ejecutar una sola vez.
    if (window.__smBooted) return;
    window.__smBooted = true;
    // Cada init es independiente: si uno falla, los demás siguen funcionando.
    [initReveals, initCarousels, initStickyCta, initProgress, initHeaderScroll,
     initOverHero, initHeroVideo, initBlueblockers, initGallery, initVariants,
     initMobileMenu, initSpotlight, initCountUp, initResenas].forEach(function (fn) {
      try { fn(); } catch (e) { /* noop */ }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
